import { useMemo } from 'react';
import { connect } from 'react-redux';
import CommonMessage from 'conversations-visitor-message-history/common-message/CommonMessage';
import { QUICK_REPLY_VARIANT } from 'conversations-visitor-message-history/quick-reply/constants/quickReplies';
import useIsSpotlightLauncher from '../../../hooks/useIsSpotlightLauncher';
import { hasTextContent } from 'conversations-message-history/web/common-message/operators/hasTextContent';
// @ts-ignore Untyped Dependency
import { isFromVisitor } from 'conversations-message-history/common-message-format/operators/senderTypeComparators';
import SpotlightAttachments from '../../../spotlight/attachment-card/SpotlightAttachments';
import { fileAttachmentIdsInMessage } from 'conversations-message-history/common-message-format/operators/fileAttachmentIdsInMessage';
import { useResolvedFileAttachments } from '../../../resolved-attachments/hooks/useResolvedFileAttachments';
import { isStarted } from '../../../threads/operators/isStarted';
import { isClosed } from '../../../threads/operators/isClosed';
import { isPersistedThread } from '../../../threads/operators/isPersistedThread';

// @ts-ignore Untyped Dependency
import { publishVisitorMessage } from '../../../pubsub/actions/publishVisitorMessage';
import { dispatchFeedbackChain } from '../../../pubsub/actions/dispatchFeedbackChain';
// @ts-ignore Untyped Dependency
import { hasUnansweredQuickReplyMessage } from '../../../selectors/chatSelectors';
// @ts-ignore Untyped Dependency
import { getSelectedThread } from '../../../selected-thread/selectors/getSelectedThread';
import { toggleOpen } from '../../../actions/WidgetActions';
import { getIsMobile } from '../../../selectors/getIsMobile';
import { getWidgetDataLanguage, getIsUngatedForCustomerAgentFeedback, getUseSpotlightLauncher } from '../../../widget-data/selectors/widgetDataSelectors';
import { navigateToKnowledgeBaseArticle } from '../../../navigation/actions/navigateToKnowledgeBaseArticle';
import { withBrowserSizeContext } from '../../../containers/withBrowserSizeContext';
// @ts-ignore Untyped Dependency
import { getFilteredMessages } from '../../selectors/getFilteredMessages';
import { getColoring } from '../../../selectors/widgetDataSelectors/getColoring';
import { postQuickLinkButtonClickEvent } from '../../../pubsub/actions/postQuickLinkButtonClickEvent';
import { isSpeechPocPortal } from '../../../utils/isSpeechPocPortal';
import { getUnpublishedMessagesForCurrentThread } from '../../../pubsub/selectors/getUnpublishedMessagesForCurrentThread';
// @ts-ignore Untyped Dependency
import { getCurrentThreadHistoryData } from '../../selectors/getCurrentThreadHistoryData';
// @ts-ignore Untyped Dependency
import { getCurrentThreadHistoryEntry } from '../../selectors/getCurrentThreadHistoryEntry';
import { isSucceeded, isFailed } from '../../../constants/asyncStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => {
  var _state$speechPoc, _state$speechPoc2;
  const selectedThread = getSelectedThread(state);
  const coloring = getColoring(state);
  const isPersisted = isPersistedThread(selectedThread);
  return {
    hasUnansweredQuickReplyMessage: hasUnansweredQuickReplyMessage(state, {
      thread: selectedThread
    }),
    isThreadStarted: isStarted(selectedThread),
    mobile: getIsMobile(state),
    locale: getWidgetDataLanguage(state),
    messagesList: getFilteredMessages(state),
    unpublishedMessages: getUnpublishedMessagesForCurrentThread(state),
    threadHistoryData: getCurrentThreadHistoryData(state),
    isThreadHistoryLoaded: !isPersisted || isSucceeded(getCurrentThreadHistoryEntry(state)) || isFailed(getCurrentThreadHistoryEntry(state)),
    speechPocActive: isSpeechPocPortal() && ((_state$speechPoc = state.speechPoc) === null || _state$speechPoc === void 0 ? void 0 : _state$speechPoc.speechPocActive),
    audioPlaybackStatus: (_state$speechPoc2 = state.speechPoc) === null || _state$speechPoc2 === void 0 ? void 0 : _state$speechPoc2.audioPlaybackStatus,
    accentColor: coloring.accentColor,
    isUngatedForCustomerAgentFeedback: getIsUngatedForCustomerAgentFeedback(state),
    isThreadClosed: isClosed(selectedThread),
    quickReplyVariant: getUseSpotlightLauncher(state) ? QUICK_REPLY_VARIANT.SPOTLIGHT : QUICK_REPLY_VARIANT.DEFAULT
  };
};
const mapDispatchToProps = {
  navigateToKnowledgeBaseArticle,
  publishMessage: publishVisitorMessage,
  dispatchFeedbackChain,
  toggleOpen,
  onQuickLinkClick: postQuickLinkButtonClickEvent
};
const connected = connect(mapStateToProps, mapDispatchToProps);
const BaseConnected = connected(withBrowserSizeContext(CommonMessage));
const ConnectedCommonMessage = props => {
  const isSpotlight = useIsSpotlightLauncher();
  const fileIds = useMemo(() => fileAttachmentIdsInMessage(props.message).toArray(), [props.message]);
  const fileAttachments = useResolvedFileAttachments(fileIds);
  if (isSpotlight) {
    const hasText = hasTextContent(props.message);
    const fromVisitor = isFromVisitor(props.message);
    if (!hasText) {
      return /*#__PURE__*/_jsx(SpotlightAttachments, {
        fileAttachments: fileAttachments,
        fromVisitor: fromVisitor
      });
    }
    return /*#__PURE__*/_jsx(BaseConnected, Object.assign({}, props, {
      fileAttachments: [],
      children: /*#__PURE__*/_jsx(SpotlightAttachments, {
        fileAttachments: fileAttachments,
        fromVisitor: fromVisitor,
        isInline: true
      })
    }));
  }
  return /*#__PURE__*/_jsx(BaseConnected, Object.assign({}, props, {
    fileAttachments: fileAttachments
  }));
};
ConnectedCommonMessage.displayName = 'ConnectedCommonMessage';
export default ConnectedCommonMessage;